import { IntlShape } from 'react-intl';

const getDescription = ({
  publishedAt, title, city, addressRegion, postalCode,
}: {
  publishedAt: string | null;
  title: string;
  city: string;
  addressRegion: string | null;
  postalCode: string | null;
}, intl: IntlShape) => {
  const location = [city, addressRegion, postalCode]
    .filter(Boolean).join(', ');

  return [
    publishedAt && intl.formatDate(publishedAt, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }),
    title,
    location,
  ].filter(Boolean).join(' - ');
};

export default getDescription;
